import React, { useEffect, useState } from "react";
import img from "./img";
import "./css/Main.css";

function Main() {
  const [image, setImage] = useState(img[0]);

  useEffect(() => {
    setInterval(() => {
      let ranImg = Math.floor(Math.random() * img.length);

      let randomImage = img[ranImg];
      setImage(randomImage);
    }, 5000);
    // console.log(image);
  }, []);

  return (
    <div className="main">
      <div className="main-content">
        <div className="main-content-text">
          <p className="main-text">
            Grow up skills <br /> and turn dreams into reality
          </p>
          <span />
          <p>
            We are a group of young passionate graduates dedicated to provide
            the platform to learn the skills that colleges not provide. We
            ignite the young minds to learn the skills in college days.
          </p>
        </div>
        <div className="main-content-img">
          <img src={image.src} alt="logo" />
        </div>
      </div>
    </div>
  );
}

export default Main;
